import React from "react";
import Typography from "@mui/material/Typography";

const ComingSoon = () => {
    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "#333",
            }}
        >
            <Typography
                variant="h1"
                style={{
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    marginBottom: "10px",
                    marginTop: "-350px", // Moves the heading upwards
                }}
            >
                Coming Soon!
            </Typography>
            <Typography
                variant="body1"
                style={{
                    fontSize: "1rem",
                    fontWeight: "300",
                    color: "#666",
                }}
            >
                We’re working hard to bring this feature to life. Stay tuned!
            </Typography>
        </div>
    );
};

export default ComingSoon;
